// src/pages/PartnerWithUsSpanish.js
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from 'react-router-dom';
import emailjs from 'emailjs-com';
import { Helmet } from "react-helmet";

function PartnerWithUsSpanish() {

  const [data, setData] = useState([]);

  useEffect(() => {
      fetch("https://culturlingua.com/api.php")
          .then((response) => response.json())
          .then((data) => setData(data))
          .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    emailjs.send(
      'service_9lb5qor',      
      'template_lbosaog',     
      data,                   
      'E34tJabSp_CQoJAQZ'     
    )
    .then((response) => {
      console.log('Email sent successfully:', response);
      alert("Tu solicitud ha sido enviada exitosamente. Nos pondremos en contacto pronto.");
    })
    .catch((error) => {
      console.error('Email send failed:', error);
      alert("Hubo un error al enviar tu formulario. Intenta nuevamente.");
    });
  };

  return (
    <section className="">

        <Helmet>
        <title>Clases de Inglés en México | Culturlingua</title>
        <meta
          name="description"
          content="Spanish course in Mexico.  Certified teachers, Spanish MCER,  international Spanish."
        />
        <meta
          name="keywords"
          content="Spanish classes, Spanish courses, Spanish online, Spanish in Mexico, learn Spanish fast,  Culturlingua, Tlaquepaque, Tlaquepaque Jalisco, Spanish classes in Tlaquepaque, Spanish schools in Tlaquepaque"
        />
        <meta name="author" content="Culturlingua" />
      </Helmet>

      <div className="home-container">
        <div className="overlay"></div>

        <div className="home-content">
          <h1>Partner With Us</h1>
          <p>Partner with Culturlingua Jalisco and offer personalized Spanish course packages to your students.</p>
          <br /><br />
        </div>
      </div>

      {/* Carousel */}
      <section className="carousel-section">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          className="carousel-container"
        >
          <SwiperSlide>
            <div className="slide-content">
              <img src="./assets/internationalization.png" alt="International partnerships" />
              <div className="text">
                <h2>Internationalization</h2>
                <p>Partner with us and offer Spaish learning and experience programs..</p>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="slide-content">
              <img src="./assets/tlaquepaque.avif" alt="Cultural immersion" />
              <div className="text">
                <h2>Spanish Groups</h2>
                <p>Bring your students and enjoy a full immersive cultural experience in Jalisco, Mexico.</p>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="slide-content">
              <img src="./assets/number.webp" alt="Language schools collaboration" />
              <div className="text">
                <h2>Language Schools</h2>
                <p>Offer your alumni unique Spanish packages, tailored and designed for diverse levels and necessities.</p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>

      {/* Benefits */}
      <section className="benefits">
        <h2>Why should you partner with us?</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <h3>🌎 International Experience</h3>
            <p>We receive and welcome students from different <b>countries</b> and <b>cultures</b>.</p>
          </div>
          <div className="benefit-card">
            <h3>🏫 Specialized programs</h3>
            <p>Courses <b>adapted</b> to groups, agencies, and language schools.</p>
          </div>
          <div className="benefit-card">
            <h3>🎉 Cultural Activities</h3>
            <p>Students will <b>live</b> authentic experiences in Mexico.</p>
          </div>
          <div className="benefit-card">
            <h3>🤝 Flexibility</h3>
            <p>We design <b>tailored</b> packages.</p>
          </div>
        </div>
      </section>

      {/* About Partnership */}
      <section className="about-linguahub">
        <h2>Let's Build Together</h2>
        <p>
          At <b>Culturlingua</b> we believe in colaboration. We partner with agents, international groups and language schools
          to offer <b>unique</b> Spanish learning experiences in Mexico. 
        </p>
        <p>
          From short programs to full packages, we design and tailor the best option for your students.
        </p>
      </section>

      {/* Contact Form */}
      <section className="contact-form">
        <h2>Interested in partnering with us?</h2>
        <p>Send your information and schedule a meeting to get to know our colaboration options.</p>
        <form onSubmit={handleSubmit}>
          <input type="text" name="nombre" placeholder="Your name" required />
          <input type="email" name="correo" placeholder="Your e-mail" required />
          <input type="text" name="telefono" placeholder="Your phone number (optional)" />
          <textarea name="pregunta" placeholder="Tell us about your interest in partnering with us..." required></textarea>
          <button type="submit">Send</button>
        </form>
      </section>
      <br /><br />
    </section>
  );
}

export default PartnerWithUsSpanish;
